/* unplugin-vue-components disabled */import { render } from "./audioItem.vue?vue&type=template&id=0424d1ec&scoped=true"
import script from "./audioItem.vue?vue&type=script&lang=js"
export * from "./audioItem.vue?vue&type=script&lang=js"

import "./audioItem.vue?vue&type=style&index=0&id=0424d1ec&scoped=true&lang=scss"
import "./audioItem.vue?vue&type=style&index=1&id=0424d1ec&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0424d1ec"]])

export default __exports__